import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body/Body'
import { Footer } from './Footer'
import { Header } from './Header'
import { InvalidBody } from './InvalidBody'

type Props = {
  orderStepIds: string[]
}

export function Content(props: Props) {
  const { ready, invalid } = useConfigureController(props.orderStepIds)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      {invalid ? <InvalidBody /> : <Body />}
    </ModalContent>
  )
}
